// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetPagesByParentApiParameter } from "@insite/client-framework/Services/ContentService";
import FeatureNotesListState from "@store/Framework/Store/Greif/Pages/FeatureNotesList/FeatureNotesListState";
import { Draft } from "immer";

const initialState: FeatureNotesListState = {
    getFeatureNotesPagesParameters: {},
};

const actions = {
    "Greif/Pages/FeatureNotesList/UpdateLoadParameter": (
        draft: Draft<FeatureNotesListState>,
        { parameter }: { parameter: GetPagesByParentApiParameter },
    ) => {
        let existingParameter = draft.getFeatureNotesPagesParameters[parameter.parentNodeId];
        if (!existingParameter) {
            existingParameter = {
                parentNodeId: parameter.parentNodeId,
            };
        }

        existingParameter = { ...existingParameter, ...parameter };
        draft.getFeatureNotesPagesParameters[parameter.parentNodeId] = existingParameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifFeatureNotesPagesActions = Parameters<typeof reducer>[1];
export default reducer;
